import dayjs from "dayjs";
import { WRAPSODY_CLOUD_HOST } from "src/config/config";
import { ServiceNotice } from "./types";

export const BANK_INFO = {
  bank: "하나은행",
  account: "128-910004-64004",
  receiver: "주식회사 파수",
} as const;

export function getServiceUrl(
  productKey: string | undefined,
  isOciProduct: boolean,
  domainName: string
): string {
  if (isOciProduct && productKey === "WRAPSODY") return WRAPSODY_CLOUD_HOST;
  return domainName;
}

// 사이트 생성 프로그레스바 메시지
export function getCreateStepMessage(
  notice: ServiceNotice,
  t: (k: string) => string
): string {
  const map: Partial<Record<ServiceNotice, string>> = {
    SERVICE: t("siteManagement.createSite.createStepMsg_1"),
    CREATE_TENANT: t("siteManagement.createSite.createStepMsg_2"),
    REGIST: t("siteManagement.createSite.createStepMsg_3"),
    INITIALIZING: t("siteManagement.createSite.createStepMsg_3"),
    LOADING_CONFIG: t("siteManagement.createSite.createStepMsg_4"),
    DB_SETTING: t("siteManagement.createSite.createStepMsg_5"),
    SETTING_CONFIG: t("siteManagement.createSite.createStepMsg_5"),
    CREATE_CERTIFICATION: t("siteManagement.createSite.createStepMsg_6"),
    SERVICE_BOOTING: t("siteManagement.createSite.createStepMsg_7"),
    READY_FOR_DEPLOY_URL: t("siteManagement.createSite.createStepMsg_7"),
    "": "",
  };
  return map[notice] ?? "";
}

export function shouldShowDeleteButton(opts: {
  billType: "PROMOTION" | "TRIAL" | "PAY" | string;
  serviceEndTime: number | string;
  serviceNotice: ServiceNotice;
  nextPayDate?: number | null;
}): boolean {
  const nowTime = dayjs().unix();
  const end = Number(opts.serviceEndTime) || 0;
  console.log("end", end, nowTime);
  if (opts.billType === "PROMOTION" && end !== 0 && end < nowTime) return true;
  if (opts.billType === "TRIAL" && opts.serviceNotice === "") return true;
  if (opts.billType === "PAY" && !opts.nextPayDate) return true;
  return false;
}

export function calcStorageProgressPct(
  usedMB: number | string,
  licenseCount: number | string,
  userPerStorage: number | string
): number {
  const usedGB = Number(usedMB) / 1024 / 1024 / 1024;
  const quota = Number(licenseCount) * Number(userPerStorage); // GB
  if (!quota) return 0;
  return Math.min(100, (usedGB / quota) * 100);
}

export const nfKR = new Intl.NumberFormat("ko-KR");
